import GuestRegisterAddAccountUseCase from "@domains/features/LoginFlow/useCases/GuestRegisterAddAccount";
import ClientValidateOTPUseCase from "@domains/features/LoginFlow/useCases/clientValidateOTP";
import ClientGenerateOTPUseCase from "@domains/features/LoginFlow/useCases/clientGenerateOTP";
import UnblockUserUseCase from "@domains/features/LoginFlow/useCases/unblockUser";
import clientSetPasswordUseCase from "@domains/features/LoginFlow/useCases/clientSetPassword";
import ClientForgotUserIDUseCase from "@domains/features/LoginFlow/useCases/clientForgotUserID";
import ClientLoginFlowImageUseCase from "@domains/features/LoginFlow/useCases/ClientLoginFlowImage";
import ClientLoginFlowQuestionUseCase from "@domains/features/LoginFlow/useCases/ClientLoginFlowQuestions";
import guestLoginSetMpinUseCase from "@domains/features/LoginFlow/useCases/guestLoginSetMpin";
import guestForgotSetMpinUseCase from "@domains/features/LoginFlow/useCases/guestForgotSetMpin";
import GuestValidateMPINUseCase from "@domains/features/LoginFlow/useCases/GuestValidateMPIN";
import GetAccountDetailsUseCase from "@domains/features/LoginFlow/useCases/getAccountDetails";
import ClientLoginDataUseCase from "@domains/features/LoginFlow/useCases/ClientLoginVerifyAnswers";
import GuestForgotPINUseCase from "@domains/features/LoginFlow/useCases/guestForgotPIN";
import checkNAddEmailUseCase from "@domains/features/LoginFlow/useCases/checkNAddEmailUseCase";
import GuestRegValidateOTPUseCase from "@domains/features/LoginFlow/useCases/GuestRegValidateOTPUseCase";
import GuestRegEmailVerifyOTPUseCase from "@domains/features/LoginFlow/useCases/GuestRegEmailVerifyOTPUseCase";
import TotpGenerateOtpUseCase from "@domains/features/LoginFlow/useCases/totpGenerateOtpUseCase";
import TotpValidateOtpUseCase from "@domains/features/LoginFlow/useCases/totpValidateOtpUseCase";
import TotpStreamUseCase from "@domains/useCases/totpStreamUseCase";
export default (function (repositories) {
    return {
        login: {
            guestRegisterAddAccount: new GuestRegisterAddAccountUseCase(repositories.login),
            clientValidateOTP: new ClientValidateOTPUseCase(repositories.login),
            clientGenerateOTP: new ClientGenerateOTPUseCase(repositories.login),
            unblockUser: new UnblockUserUseCase(repositories.login),
            clientSetPassword: new clientSetPasswordUseCase(repositories.login),
            clientForgotUserID: new ClientForgotUserIDUseCase(repositories.login),
            imageClientLoginFlow: new ClientLoginFlowImageUseCase(repositories.login),
            clientLoginFlowQuestion: new ClientLoginFlowQuestionUseCase(repositories.login),
            checkNAddEmailUseCase: new checkNAddEmailUseCase(repositories.login),
            guestLoginSetMpin: new guestLoginSetMpinUseCase(repositories.login),
            guestForgotSetMpin: new guestForgotSetMpinUseCase(repositories.login),
            guestValidateMPIN: new GuestValidateMPINUseCase(repositories.login),
            getAccountDetails: new GetAccountDetailsUseCase(repositories.login),
            clientLoginData: new ClientLoginDataUseCase(repositories.login),
            guestForgotPIN: new GuestForgotPINUseCase(repositories.login),
            guestValidate: new GuestRegValidateOTPUseCase(repositories.login),
            guestRegEmailVerifyOTP: new GuestRegEmailVerifyOTPUseCase(repositories.login),
            totpGenerateOtp: new TotpGenerateOtpUseCase(repositories.login),
            totpValidateOtp: new TotpValidateOtpUseCase(repositories.login)
        },
        totp: new TotpStreamUseCase(repositories.quoteStream)
    };
});
